import { makeStyles, createStyles } from '@material-ui/core';
import Colors from '../Colors';

export const optionStyles = makeStyles((theme) =>
  createStyles({
    filterBar: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    responsive: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      gap: '0.5rem',
      flexWrap: 'wrap',
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '100%',
      },
    },
    formControl: {
      margin: '5px 0px',
      height: 35,
      [theme.breakpoints.down('sm')]: {
        marginTop: 10,
      },
    },
    submitButton: {
      fontFamily: 'Texta Medium',
      color: Colors.white,
      backgroundColor: Colors.main,
      height: 35,
      '&:hover': {
        backgroundColor: Colors.hoverMain,
        fontFamily: 'Texta Heavy',
      },
      [theme.breakpoints.down('sm')]: {
        height: '40px',
      },
    },
    textField: {
      padding: '0 5px 0 10px',
      marginRight: '8px',
      width: 160,
      height: '34px',
      borderRadius: '5px',
      border: '1px solid #C4C4C4',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    selectField: {
      display: 'flex',
      flexDirection: 'row',

      width: 200,
      height: 35,
      marginRight: 10,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        maxWidth: '100%',
      },
    },
    dateInput: {
      height: '34px',
      width: 165,
      margin: 0,
      marginRight: 10,
      backgroundColor: 'white',
      overflow: 'hidden',
      boxSizing: 'border-box',
    },
    selectLabel: {
      fontSize: 14,
    },
    groupFilter: {
      display: 'flex',
      flexDirection: 'row',
      [theme.breakpoints.down('sm')]: {
        margin: '4% 0 2% 0',
      },
    },
    addIncidentButton: {
      marginTop: -10,
      marginBottom: -20,
      zIndex: 1000,
    },
    filterIconButton: {
      marginTop: 2,
      width: 40,
      height: 40,
    },
    filterIcon: {
      height: 30,
      width: 30,
      fil: 'red',
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      height: '200px',
      width: '50%',
    },
    rootForm: {
      display: 'flex',
      flexFlow: 'column',
    },
    rootButton: {
      backgroundColor: Colors.secundary,
      color: '#404040',
      fontFamily: 'Roboto',
      fontWeight: 'bold',
      alignSelf: 'flex-end',
    },
  }),
);
